(function(){
 'use strict';
 var root=document.querySelector('[data-mrak-stockists]');
 if(!root||root.dataset.ready)return;
 var source=root.querySelector('[data-stockists-source]'),lines=[],current={text:'',links:[]};
 function flush(){if(current.text.trim()||current.links.length)lines.push({text:current.text.trim(),links:current.links});current={text:'',links:[]};}
 function walk(node){
  if(node.nodeType===3){current.text+=node.textContent;return;}
  if(node.nodeType!==1)return;
  if(node.tagName==='BR'){flush();return;}
  if(node.tagName==='A'){
   var url=new URL(node.getAttribute('href'),location.origin);
   if(url.protocol!=='https:'&&url.protocol!=='http:')throw new Error('Unsupported link');
   current.text+=node.textContent;current.links.push({text:node.textContent.trim(),url:url.href});return;
  }
  Array.from(node.childNodes).forEach(walk);
  if(/^(P|DIV|H[1-6]|LI)$/.test(node.tagName))flush();
 }
 function el(tag,cls,text){var e=document.createElement(tag);if(cls)e.className=cls;if(text)e.textContent=text;return e;}
 try{
  walk(source);flush();
  var groups=[],intro=[],notes=[],group=null,region=null,store=null;
  lines.forEach(function(line){
   var text=line.text;
   if(/^[＿_―—\s]+$/.test(text))return;
   if(/^[▪■]/.test(text)){
    group={title:text.replace(/^[▪■︎\s]+/u,''),regions:[]};groups.push(group);region=null;store=null;return;
   }
   if(/^【.+】$/.test(text)&&group){region={title:text.slice(1,-1),stores:[]};group.regions.push(region);store=null;return;}
   if(/^[・•]/.test(text)&&group){
    if(!region){region={title:'',stores:[]};group.regions.push(region);}
    var parts=text.replace(/^[・•]\s*/,'').split(/[｜|]/);
    store={name:parts.shift().trim(),location:parts.join(' / ').trim(),links:line.links};region.stores.push(store);return;
   }
   if(line.links.length&&store){store.links=store.links.concat(line.links);return;}
   if(!group)intro.push(text);else if(text){notes.push(text);store=null;}
  });
  var count=groups.reduce(function(n,g){return n+g.regions.reduce(function(a,r){return a+r.stores.length;},0);},0);
  if(!count||source.querySelectorAll('a').length!==groups.reduce(function(n,g){return n+g.regions.reduce(function(a,r){return a+r.stores.reduce(function(b,s){return b+s.links.length;},0);},0);},0))return;
  var fragment=document.createDocumentFragment(),opening=el('div','mrs-intro');
  intro.forEach(function(t){opening.appendChild(el('p','',t));});fragment.appendChild(opening);
  var nav=el('div','mrs-nav');
  groups.forEach(function(g,i){var a=el('a','',g.title);a.href='#stockists-'+i;nav.appendChild(a);});fragment.appendChild(nav);
  groups.forEach(function(g,i){
   var section=el('section','mrs-section'),heading=el('h2','',g.title);section.id='stockists-'+i;heading.id=section.id+'-title';section.setAttribute('aria-labelledby',heading.id);section.appendChild(heading);
   g.regions.forEach(function(r){
    var regionEl=el('div','mrs-region');if(r.title)regionEl.appendChild(el('h3','mrs-region-title',r.title));else regionEl.classList.add('mrs-no-region');
    var list=el('ul','mrs-list');r.stores.forEach(function(s){
     var li=el('li','mrs-store');li.appendChild(el('h4','mrs-name',s.name));if(s.location)li.appendChild(el('p','mrs-place',s.location));
     var links=el('div','mrs-links');s.links.forEach(function(link){var a=el('a','',link.text),arrow=el('span','',' →');arrow.setAttribute('aria-hidden','true');a.href=link.url;a.appendChild(arrow);links.appendChild(a);});li.appendChild(links);list.appendChild(li);
    });regionEl.appendChild(list);section.appendChild(regionEl);
   });fragment.appendChild(section);
  });
  var footer=el('div','mrs-notes');notes.forEach(function(t){footer.appendChild(el('p','',t));});fragment.appendChild(footer);
  source.replaceWith(fragment);root.dataset.ready='true';root.dataset.storeCount=String(count);
 }catch(error){}
})();
